import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'listItem'
})
export class ListItemPipe implements PipeTransform {
  transform(value: any, entity: string): unknown {
    if (entity === 'employee') {
      return `${value.lastname} ${value.firstname}`;
    } else if (entity === 'team' && value.isStructural) {
      return `${value.name} (${value.positionOrder})`;
    } else if (entity === 'prestation-type') {
      return `${value.name} (${value.startHours} - ${value.endHours})`;
    } else if (entity === 'exchange-request') {
      return value.key;
    } else if (entity === 'absence') {
      return `#${value.reference}`
    } else {
      return value.name;
    }
  }
}
